import { SkeletonStatus as DsSkeletonStatus } from '@natter-co/design-system';
import { useInheritedVisualRefresh } from 'common/theme';

import type { SkeletonStatusProps } from '@natter-co/design-system';

/** The legacy placeholders retain their semantics while the refreshed region gets one status. */
export const SkeletonStatus = (props: SkeletonStatusProps) =>
  useInheritedVisualRefresh() ? <DsSkeletonStatus {...props} /> : null;
